import { GenericABTestingFlag, useFeatureFlags } from '@usap/core'
import { getAllowedPartForDifm3 } from '../../utility/allowedPartsForDifm3'

const useIsRepairPalPricingEnabled = (partForFlag?: string) => {
  const part = getAllowedPartForDifm3(partForFlag || '')
  const rppFlag = `rpp_${part}`
  const { [rppFlag]: rppPart } = useFeatureFlags()

  return rppPart === 'b' as GenericABTestingFlag
}

export default useIsRepairPalPricingEnabled
